import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import SolicitudesComponent from './Solicitudes/SolicitudesComponent';
import TabSolicitudesComponent from './Solicitudes/TabSolicitudesComponent';


function PanelSolicitudes(props) {


    return (
        <Fragment><br />
            <div className='container'>
                <div className='row'>
                    <div className='col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-3'>
                        <p style={{ fontSize: '25px' }}>Solicitudes</p>
                    </div>
                    <TabSolicitudesComponent />
                    {/* <SolicitudesComponent></SolicitudesComponent> */}
                </div>
            </div>
        </Fragment>
    );
};


export default withRouter(PanelSolicitudes)
